module.exports = __webpack_public_path__ + "static/img/ys_btn2.6c5e3ee.png";


//////////////////
// WEBPACK FOOTER
// ./static/hk/img/home/pc/role3/control/ys_btn2.png
// module id = DK+g
// module chunks = 7